
import PaymentLinksTable from "../../components/PaymentLinks/PaymentLinksTable";

const PaymentLinks = () => {

    return (
        <PaymentLinksTable />
    );

}
export default PaymentLinks;
